/**
 * Takes an array of type T | null | undefined,
 * removes the nulls and undefineds,
 * and returns an array of type T
 */
export function removeEmpty<T>(xs: (T | null | undefined)[]): T[] {
  return xs.flatMap((x) => (x === undefined || x === null ? [] : [x]));
}
